import { ChevronRightIcon } from '@chakra-ui/icons'
import cx from 'classnames'
import { useStores } from 'hooks/useStores'
import get from 'lodash/get'
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import colors from 'theme/colors.theme'
import Badge from 'components/Badge'
import { ERouteName, SidebarItem } from 'components/LeftSidebar/components/SideBarContent/constants'
import SvgIcon from 'components/SvgIcon'
import routes from 'routes'
import styles from './styles.module.scss'
import useBreakPoint from 'hooks/useBreakPoint'
import { EBreakPoint } from 'constants/theme'

interface IMenuItemLinkProps {
  isExpanded?: boolean
  item: SidebarItem
  className?: string
  nameContainerClassName?: string
  arrowClassName?: string
}

const MenuItemLink = ({ isExpanded, item, className, nameContainerClassName, arrowClassName }: IMenuItemLinkProps) => {
  const { notificationStore, messageStore, authStore, organizationStore, generalStore } = useStores()
  const { organization } = organizationStore
  const isLightSideBar: boolean = organization?.isLightSideBar ?? false
  const { userDetail } = authStore
  const { countNotifications = 0 } = notificationStore
  const { unreadSupportThreadCount = 0 } = messageStore
  const { showSidebarMobile } = generalStore
  const isMobile: boolean = useBreakPoint(EBreakPoint.BASE, EBreakPoint.MD)
  const isDashboardItem = item.name === ERouteName.DASHBOARD

  function routeTo(): string {
    if (item?.path === routes?.processes?.value) {
      return `${routes?.processes?.value}?creatorIds=${userDetail?.id}`
    }

    return String(get(item, 'children[0].path') ? get(item, 'children[0].path') : item?.path) || ''
  }

  function handleClick() {
    isMobile && generalStore.setShowSidebarMobile(!showSidebarMobile)
    document?.body?.classList?.remove('sidebar-enable')
  }

  return (
    <Link
      to={routeTo()}
      className={cx('side-nav-link-ref', 'side-sub-nav-link', className, styles.container, {
        [styles.sideNavDashboard]: isDashboardItem
      })}
      onClick={handleClick}
    >
      {item?.iconName && isLightSideBar && (
        <SvgIcon size={isExpanded ? 24 : 18} iconName={item.iconName} color={'#1A202C'} />
      )}
      {item?.iconName && !isLightSideBar && <SvgIcon size={isExpanded ? 24 : 18} iconName={item.iconName} />}
      {item.badge && (
        <Badge color="success" className={styles.badge}>
          {item?.badge?.text}
        </Badge>
      )}
      <span
        style={{ color: isLightSideBar ? colors.gray[600] : colors.gray[200] }}
        className={cx(nameContainerClassName, styles.text)}
      >
        {item.name}{' '}
      </span>
      {routes.notifications.value === item.path && countNotifications ? (
        <div className={styles.countNotifications}>{countNotifications}</div>
      ) : null}
      {routes.messages.value === item.path && unreadSupportThreadCount > 0 ? (
        <div className={styles.countNotifications}>{unreadSupportThreadCount}</div>
      ) : null}
      {item?.children?.length && <ChevronRightIcon className={cx(styles.expandIcon, 'expand-child', arrowClassName)} />}
    </Link>
  )
}

export default observer(MenuItemLink)
